import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils/validator-generator';

@Component({
  selector: 'pt-treatment-input-navigation-data',
  templateUrl: './treatment-input-navigation-data.component.html',
  styleUrls: ['./treatment-input-navigation-data.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TreatmentInputNavigationDataComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TreatmentInputNavigationDataComponent),
      multi: true
    }
  ]
})
export class TreatmentInputNavigationDataComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() controlName: string;
  @Input() label: string;
  @Input() enabledEdit: boolean;
  @Input() validators: WidgetValidator[];

  @Output() clickEdit = new EventEmitter();
  @Output() clickCancel = new EventEmitter();
  @Output() clickSaveChange = new EventEmitter();
  @Output() clickInput = new EventEmitter();


  public formGroup: FormGroup;
  isChanged = false;
  isDisabled = false;
  isRequired: boolean;
  inputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWTreatmentInputNavigationData_' + this.controlName;

    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t.value !== null;

      if (this.onChanged) {
        this.onChanged(t ? t.value : t);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: any): void {
    this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.formGroup.controls.value.disable({emitEvent: false});
    } else {
      this.formGroup.controls.value.enable({emitEvent: false});
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    const validator = ValidatorGenerator.generateValidator(this.validators);

    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });
  }
}
